import { ApiHandler, createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { BranchModel, getBranchById } from "@tCentro/Services/CENAdminBranchService";

export interface GetBranchByIdParameter extends HasOnSuccess<BranchModel>, HasOnError<string> {
    id: string;
}
 
type HandlerType = ApiHandler<GetBranchByIdParameter, { apiResult: BranchModel }>;
 
export const GetBranchById: HandlerType = async props => {
    try {
           const result = await getBranchById(props.parameter.id);
           if (props.parameter.onSuccess) {
               props.parameter.onSuccess(result);
           }
       } catch (error: any) {
           if (props.parameter.onError) {
               props.parameter.onError(error?.message ?? "Failed to load Branches");
           }
       }
};
 
export const chain = [GetBranchById];
const getBranchByIdHandler = createHandlerChainRunner(chain, "getBranchByIdHandler");
export default getBranchByIdHandler;